export default { sha: '0b3e662093420b12d2ebf2100669044d9696d4dd', buildNumber: 'undefined' }
